export const objToFieldsArray = (obj: any) => {
    let result: any[] = [];
    let count = 0;

    function f(object: any, parentObj?: any) {
        let keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
            if (object[keys[i]] !== null) {
                if (typeof object[keys[i]] !== "object") {
                    count++;
                    result.push({
                        label: keys[i],
                        value: object[keys[i]],
                        parentObj: parentObj,
                        id: count
                    });
                } else {
                    count++;
                    result.push({
                        label: keys[i],
                        value: JSON.stringify(object[keys[i]]),
                        parentObj: parentObj,
                        id: count
                    });
                    // f(object[keys[i]], parentObj !== undefined ? `${parentObj}.${keys[i]}` : keys[i])
                }
            }

        }
    }

    f(obj);
    return result
};

export function ArrayToObject(arr: { code: string, value: string }[]) {
    if (Array.isArray(arr)) {

        return arr.reduce(
            (obj: any, item: any) => Object.assign(obj, {[item.code]: item.value}), {});
    } else return {}

}



